<div fxLayout>
  <sbnb-subnav
    fxHide.lt-md
    fxFlex="280px"
    fxHide.lt-md
    [header]="'PROPERTIES.PROPERTIES' | transloco"
    [settingsLink]="'/settings/properties'">
    <sbnb-saved-segments
      key="properties"
      [quickFilterKeys]="quickFilters"
      [activeId]="activeSegmentUuid"
      (quickFilterChange)="quickFilterChange($event)"></sbnb-saved-segments>

    <sbnb-helptext-wrapper [area]="'sidebar'" [pageId]="'property'"></sbnb-helptext-wrapper>
  </sbnb-subnav>

  <main fxFlex class="subnav__exists" [ngClass.lt-md]="{ mobile: true, subnav__exists: false }">
    <div fxLayout="row" fxLayout.lt-md="column">
      <app-feature-flag-tabs>
        <sbnb-page-header [parentPath]="'menu-mobile'" navTabs>
          <h2 class="mb-0">
            {{ activeSegmentTitle ? activeSegmentTitle : 'Loading...' }}
          </h2>
        </sbnb-page-header>

        <h2 class="mb-0">
          {{ activeSegmentTitle ? activeSegmentTitle : 'Loading...' }}
        </h2>
      </app-feature-flag-tabs>
    </div>

    <sbnb-helptext-wrapper
      class="helptext-wrapper-type-content"
      [area]="'content'"
      [pageId]="'property'"></sbnb-helptext-wrapper>

    <sbnb-helptext-wrapper [area]="'intro'" [pageId]="'property'"></sbnb-helptext-wrapper>

    <div class="rules__filters-container properties-filter-container" fxLayout fxLayoutGap="16px">
      <sbnb-filter
        #filterComponent
        *ngIf="segmentFilterDefaults"
        [defaultFilters]="segmentFilterDefaults"
        fxFlex
        componentName="properties"
        (filterChanged)="handleFilterChanged($event)"
        (reset)="filterReset()"></sbnb-filter>
      <div fxFlex="350px" fxFlex.lt-md>
        <sbnb-search-bar
          placeholderText="Property or listing name"
          [initialVal]="searchCriteria"
          (searchChanged)="searchUpdated($event)"></sbnb-search-bar>
      </div>
    </div>

    <div *ngIf="loading" class="table__no-items">Loading properties...</div>

    <ng-container *ngIf="!loading">
      <sbnb-no-items
        *ngIf="
          (!loading && !properties) || (properties?.length === 0 && activeSegmentIdentifier !== 'global-properties-new')
        "
        icon="properties"
        text="No properties found matching these filters"></sbnb-no-items>

      <sbnb-no-items
        *ngIf="
          (!loading && !properties) || (properties?.length === 0 && activeSegmentIdentifier === 'global-properties-new')
        "
        icon="properties"
        text="We haven't detected any new properties on your {{
          'CORE.PRODUCT_NAME' | transloco
        }} account at the moment.

          {{ 'CORE.PRODUCT_NAME' | transloco }}'s onboarding assistant allows you to onboard new properties with ease."
        [buttons]="[{ id: 'moreinfo', label: 'Read more about this function' }]"
        (button)="noItemsButtonClicked($event)"></sbnb-no-items>

      <div *ngIf="properties && properties.length > 0" class="rules__container">
        <div fxLayout fxHide.lt-md class="rules__rule-header" fxLayoutGap="8px">
          <div fxFlex>Property name</div>
          <div fxFlex="17">Listings</div>
          <div fxFlex="17">Sync</div>
          <div fxFlex="112px">Platforms</div>
        </div>

        <ng-container *ngFor="let property of properties">
          <ng-container
            *ngTemplateOutlet="propertyTemplate; context: { $implicit: property, isChild: false }"></ng-container>
        </ng-container>
      </div>

      <div
        *ngIf="selectedProperties.length > 0"
        fxLayout
        fxLayoutAlign="start center"
        fxLayout.lt-md="column"
        fxLayoutGap.lt-md="8px"
        class="properties__merge-container box-shadow-heavier">
        <span fxFlex>
          {{ selectedProperties.length }}
          {{ selectedProperties.length === 1 ? 'property selected - select 2 or more.' : 'properties selected.' }}
        </span>
        <div fxLayout fxLayoutGap="8px">
          <sbnb-button
            *ngIf="selectedProperties.length > 1"
            (clicked)="mergeProperties()"
            [disabled]="mergingProperties || (selectedProperties | propertyIsInParentChildSetup)"
            [loading]="mergingProperties"
            [matTooltip]="
              (selectedProperties | propertyIsInParentChildSetup)
                ? 'Cannot merge properties in a parent-child setup'
                : null
            "
            size="mini"
            label="Merge"></sbnb-button>

          <sbnb-button
            *ngIf="selectedProperties.length > 1 && (canUseParentChild$ | async) === true"
            label="Parent-child"
            type="primary-grape"
            size="mini"
            [disabled]="selectedProperties | propertyIsInParentChildSetup"
            [matTooltip]="
              (selectedProperties | propertyIsInParentChildSetup)
                ? 'Some properties selected are already in a parent-child setup.'
                : null
            "
            (clicked)="startParentChildSetup()"></sbnb-button>

          <!-- Upsell CTA for Parent child -->
          <sbnb-button
            *ngIf="(canUseParentChild$ | async) === false && selectedProperties.length > 1"
            type="primary-grape"
            size="mini"
            routerLink="/settings/your-plan">
            Upgrade for Parent Child
          </sbnb-button>

          <sbnb-button (clicked)="deselectAllProperties()" type="secondary" size="mini" label="Cancel"></sbnb-button>
        </div>
      </div>

      <sbnb-pagination
        *ngIf="paginationData && !loading && paginationData.page_numbers.total_pages > 1"
        position="end"
        [pageCount]="paginationData.page_numbers.total_pages"
        [currentPage]="paginationData.page_numbers.this_page"
        (pageChanged)="handlePageChanged($event)"></sbnb-pagination>
    </ng-container>
  </main>
</div>

<sbnb-mobile-sidebar [title]="'Properties'">
  <sbnb-saved-segments
    key="properties"
    [activeId]="activeSegmentUuid"
    [quickFilterKeys]="quickFilters"></sbnb-saved-segments>
</sbnb-mobile-sidebar>

<!-- Property row template -->
<ng-template #propertyTemplate let-property let-isChild="isChild" let-lastChild="lastChild">
  <a
    fxLayout
    class="rules__rule-container"
    [class.property__new]="property.is_new"
    [class.bg-smoke-lighter]="property.muted"
    [class.property__unlisted]="!property.listed"
    [class.is-last-child]="lastChild"
    fxLayoutAlign="start center"
    fxLayoutGap="8px"
    [routerLink]="['/properties/property', property.id]">
    <div
      fxFlex
      fxLayout
      fxLayoutAlign="start center"
      fxLayoutGap="8px"
      class="rule__title"
      [matTooltip]="!property.listed ? 'This property is unlisted' : null">
      <mat-checkbox
        #propertyCheckbox
        (change)="checkboxChecked($event, property)"
        (click)="$event.stopPropagation()"></mat-checkbox>

      <div *ngIf="isChild" class="child-arrow">
        <div class="child-arrow-vertical"></div>
        <div class="child-arrow-horizontal"></div>
        <div class="child-arrow-head"></div>
      </div>

      <div
        *ngIf="property.picture === '#'"
        style="width: 40px; height: 30px; background: #ddd; border-radius: 2px"></div>
      <img
        *ngIf="property.picture !== '#'"
        [src]="property.picture"
        style="width: 40px; height: 30px; border-radius: 2px" />
      <div fxFlex class="inbox__message-details property-header">
        <div fxLayout fxLayoutGap="6px" fxLayoutAlign="start center">
          <h4 class="ellipsis w-full" [class.strikethrough]="property.muted">
            {{ property.name }}
          </h4>
          <span fxFlex="0 0 auto" *ngIf="property.is_new && !property.parent_child_type" class="badge badge-grass">
            New
          </span>
          <span fxFlex="0 0 auto" *ngIf="property.parent_child_type === 'parent'" class="badge badge-grape">
            Parent
          </span>
          <span fxFlex="0 0 auto" *ngIf="property.parent_child_type === 'child'" class="badge badge-grape-lighter">
            Child
          </span>
        </div>
        <sbnb-tags *ngIf="!property.muted" [tags]="property.tags"></sbnb-tags>
        <span *ngIf="property.muted" class="text__xsmall night-lighter">Muted</span>
        <span *ngIf="propertyCheckbox.checked && property.counts?.booking > 0" class="text__xsmall night-lighter">
          Booking.com Room IDs: {{ property | listBookingListingsRoomIds }}
        </span>
      </div>
    </div>
    <div
      fxFlex="17"
      fxHide.lt-md
      class="rule__when pl-2"
      fxLayoutAlign="start center"
      fxLayoutGap="8px"
      [matTooltip]="property.types + ' Listings'">
      <span class="text__small" fxFlex>{{ property?.counts?.total || 0 }}</span>
    </div>

    <div fxFlex="17" fxHide.lt-md fxLayoutAlign="start center" fxLayoutGap="8px">
      <sbnb-icon
        icon="sync"
        class="text-smoke-darker"
        [matTooltip]="property.sync ? 'Sync is on' : 'Sync is off'"
        [style.opacity]="property.sync ? 1 : 0.3"></sbnb-icon>
    </div>

    <sbnb-scoping-icons
      class="hidden md:flex"
      [listingCounts]="{
        airbnb: property.counts.airbnb,
        homeaway: property.counts.homeaway,
        booking: property.counts.booking,
        hospitable: property.counts.direct + property.counts.manual + property.counts.gvr,
        agoda: property.counts.agoda
      }"></sbnb-scoping-icons>
  </a>

  <!-- Check for children and render them using the same template -->
  <ng-container *ngFor="let child of property.children; let lastChild = last">
    <div class="property-children">
      <ng-container
        *ngTemplateOutlet="
          propertyTemplate;
          context: { $implicit: child, isChild: true, lastChild: lastChild }
        "></ng-container>
    </div>
  </ng-container>
</ng-template>
